module.exports = __webpack_public_path__ + "static/media/Pie.af6de7c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/assets/Pie.svg
// module id = 286
// module chunks = 0